import * as React from "react"

const SvgConsentTwo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 964 1140"
  >
    <defs>
      <pattern
        id="New_Pattern_Swatch_8"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="translate(-5093.23 2153.52) scale(0.98 0.95)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <clipPath id="clip-path">
        <path
          d="M329,518a298,298,0,0,1,6.38,88.32C370.1,616.25,455,611,455,611c-3.83,16.35,0,44,0,44-29.42,23.82-114.83,19.86-114.83,19.86,2.69,26.18,20.13,46,24.26,92.58.12,1.37-2.37,24.16-8.08,24.55-4.47.31-9.05-13.26-11-19.19-12.48-37.75-91.61-324.51-60.21-330.73C285.13,442.07,321.09,483.68,329,518Z"
          fill="none"
        />
      </clipPath>
      <pattern
        id="New_Pattern_Swatch_8-3"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="matrix(-0.85, -0.37, -0.29, 1.01, 1638.81, 1797.47)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <clipPath id="clip-path-2">
        <path
          d="M217,420s-33.61,1.67-48.53,11.11c-64.88,41-102.21,157.39-85.6,181.89,21.8,32.14,80.53,50.11,80.53,50.11,8.45,79.12-13.51,140.78-13.51,140.78,10.57,10.18,43.58,1.13,73.2,9.3,52.19,14.38,100,10.67,100,10.67-8.87-30.62-26.85-61.55-25.13-109.5,3.09-86.72,7.56-90.67-11.83-174.29C278.15,505.63,270.5,475.58,217,420Z"
          fill="none"
        />
      </clipPath>
      <pattern
        id="New_Pattern_Swatch_8-5"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="matrix(-0.75, -0.74, -0.72, 0.96, 1629.19, 3893.22)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <linearGradient
        id="linear-gradient"
        x1={18318.39}
        y1={24.63}
        x2={17791.38}
        y2={923.65}
        gradientTransform="matrix(-1, 0, 0, 1, 18487.61, 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f9db87" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <pattern
        id="New_Pattern_Swatch_8-7"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="matrix(-1.06, -0.56, -0.46, 1.27, 2316.22, 2537.16)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_8-9"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="matrix(-1.06, -0.56, -0.46, 1.27, 2274.22, 2579.16)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_8-11"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="matrix(-1.06, -0.56, -0.46, 1.27, 2286.36, 2584.87)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
    </defs>
    <g
      style={{
        isolation: "isolate",
      }}
    >
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M0,817S188,459,455.18,531.52c132.35,35.93,233.22-39.46,298.89-115.41,57.58-66.59,76.09-152.91,89.63-240C857.92,84.53,900.51,40.51,961,1.67V1H0"
          fill="#351377"
        />
      </g>
      <g id="People">
        <path
          d="M261.54,924.44a167.13,167.13,0,0,0,8-27.47c.15-.74,1.29-.43,1.14.31a167.24,167.24,0,0,1-8,27.48c-.27.7-1.42.39-1.14-.32Z"
          fill="#374565"
        />
      </g>
      <g id="eyes">
        <path
          d="M200.85,1072h97.82c.78-11.74,1.62-24.72,2.55-39.26,2.82-44,11.25-85.94,14.4-116.08,5.57-53.14,5.29-92.61,10.22-122.51l-137.95-.5c-15,50.35,12.61,105.67,12.42,196.19C200.26,1018.8,200.11,1045.71,200.85,1072Z"
          fill="url(#New_Pattern_Swatch_8)"
        />
        <g>
          <path
            d="M428.9,619.66c7.29-3,9.14-2.91,20.61-12.53,7.45-6.24,6.76-7.26,11.52-10.74,12.15-8.9,25.64-10.08,26.29-7.35,2,8.4-16.88,11.6-16.7,13.44.31,3.13,6.39,2.69,14.57,1.32,8.38-1.41,21.49-13.26,24.2-9.48,2.31,3.23-3.7,8.16-10.24,13.66a43.85,43.85,0,0,1-8.44,5.61c-.18-.65,18.52-11.75,21.76-10.82a2.53,2.53,0,0,1,1.91,1.74,5.44,5.44,0,0,1-1,4.39c1.45-.42,3.86-.19,3.93,2.19.2,6.82-24.26,16.64-23.91,17.34s3.75.41,6-.54c4.61-2,8.09-9,11.07-6.43,2.56,2.21-1.79,14-20.73,21-13.78,5.07-20.64-3.17-37.17,3.57-7.49,3.06-11,6.72-15.86,5.89Z"
            fill="#dba795"
          />
          <path
            d="M496.88,608.83c-4.4,2.82-9,5.7-14.14,5.58-.55,0-.48,1,.07,1,5.28.14,10-2.85,14.57-5.75.49-.32,0-1.17-.5-.86Z"
            fill="#875348"
          />
          <path
            d="M512.8,608.77a77.67,77.67,0,0,1-12.31,8.33c-4.58,2.51-9.6,4.81-14.7,4.83-.56,0-.49,1,.07,1,5.17,0,10.27-2.35,14.92-4.88a78.41,78.41,0,0,0,12.51-8.47c.46-.38,0-1.24-.49-.85Z"
            fill="#875348"
          />
          <path
            d="M469,605.43c-1.42,8.61-6.95,15.77-14,18.16-.54.18-.25,1.16.29,1,7.3-2.48,13-10,14.52-19,.11-.66-.74-.84-.85-.18Z"
            fill="#dba795"
            opacity={0.5}
            style={{
              mixBlendMode: "multiply",
            }}
          />
        </g>
        <g clipPath="url(#clip-path)">
          <path
            d="M329,518a298,298,0,0,1,6.38,88.32c37.61,18.72,108.3,4.94,108.3,4.94,11.48,9.46,8.44,43.1,8.44,43.1-29.42,23.82-112,20.54-112,20.54,2.69,26.18-.3,23.56,3.83,70.14.12,1.38.65,35,3,47,.86,4.4.3-13.27-1.66-19.2-12.48-37.75-91.61-324.51-60.21-330.73C285.13,442.07,321.09,483.68,329,518Z"
            fill="#f15931"
          />
          <path
            d="M456.52,646.51A169.81,169.81,0,0,1,426.77,657a138.66,138.66,0,0,0-.6-19.33,121.06,121.06,0,0,0-2.4-15.49C435.38,620.53,435.88,621,447,617c1.76-.63.79-2.64-1-2-11.13,4-11.41,3-23,4.62a33.41,33.41,0,0,0-4.73-10.2c-1-1.44-3.66-.13-2.61,1.31a28.41,28.41,0,0,1,4.3,9.28c-7.39,1-14.85,1.64-22.43,1.87-8.26.25-16.54.25-24.81.25-.69-4.16-1.45-8.32-2.25-12.49-.33-1.69-3.23-1-2.9.68q1.14,5.92,2.14,11.84l-2.2,0c-10.94,0-21.88-.09-32.33-3.33a1.35,1.35,0,1,0-.81,2.57c10,3.1,20.51,3.36,31,3.42,1.58,0,3.16-.05,4.75-.05a111.94,111.94,0,0,1,1.53,19.1c-.12,6.6-.35,13.46-1.15,20.21a309.14,309.14,0,0,1-32.35-1.27c-1.91-.17-1.91,2.49,0,2.67a310.48,310.48,0,0,0,32,1.28,69.31,69.31,0,0,1-2.53,11.5c-.54,1.65,2.35,2.36,2.89.71a71.56,71.56,0,0,0,2.67-12.31,244.13,244.13,0,0,0,50.44-6.19c-.16,3-.23,6-.58,8.91-.19,1.7,2.8,1.7,3,0,.38-3.2.43-6.41.59-9.62a174.6,174.6,0,0,0,31.4-11C459.71,648,458.23,645.71,456.52,646.51Zm-83,17.49c.77-6.72,1-13.53,1.12-20.1a112.2,112.2,0,0,0-1.52-19.13c8.13,0,16.26,0,24.37-.23,7.81-.23,15.5-.94,23.12-1.92.15.65.31,1.29.45,2a129,129,0,0,1,2.71,33.14A237.52,237.52,0,0,1,373.52,664Z"
            fill="#f9f5ec"
          />
          <path
            d="M330.63,510.19a1.63,1.63,0,0,0-2.05-.5,13.71,13.71,0,0,1-5.13,1.4l-3.34.44-1.71.23-.91.12-.45.06h0a1.75,1.75,0,0,0-.74-.1,1.35,1.35,0,0,0-1.06,1.63,1.68,1.68,0,0,0,1.75,1.14,18.15,18.15,0,0,0,2.2-.29l4.21-.55a17.88,17.88,0,0,0,6.69-1.77A1.3,1.3,0,0,0,330.63,510.19Z"
            fill="#f9f5ec"
          />
          <path
            d="M336.94,548.59a1.64,1.64,0,0,0-2-.51,25.83,25.83,0,0,1-5.38,1.26l-3,.49A6.73,6.73,0,0,1,324,550a1.56,1.56,0,0,0-1.85.92,1.33,1.33,0,0,0,1,1.64,8.76,8.76,0,0,0,3.46,0l3.42-.56a30.63,30.63,0,0,0,6.31-1.55A1.26,1.26,0,0,0,336.94,548.59Z"
            fill="#f9f5ec"
          />
          <path
            d="M336.21,590.16c-.59.57-1.69.4-2.48.34-1.32-.09-2.64-.23-4-.37a66.32,66.32,0,0,0-8.22-.5,1.34,1.34,0,1,0,0,2.67,72.16,72.16,0,0,1,9.06.59c2.4.24,5.81,1,7.69-.82C339.62,590.82,337.53,588.91,336.21,590.16Z"
            fill="#f9f5ec"
          />
          <path
            d="M333.43,628.16a25.29,25.29,0,0,1-3.14,0c-1.25,0-2.49-.14-3.73-.22a69,69,0,0,1-7.19-.79,1.57,1.57,0,0,0-1.85.93,1.34,1.34,0,0,0,1,1.64,79,79,0,0,0,8.54.92c1.38.09,2.76.18,4.15.22s3.23.36,4-.79S334.55,627.81,333.43,628.16Z"
            fill="#f9f5ec"
          />
          <path
            d="M346,688.1a1.62,1.62,0,0,0-2-.51,10.06,10.06,0,0,1-3.43.67c-1.24.15-2.49.28-3.74.39l-3.85.31A21.29,21.29,0,0,1,329,689a1.43,1.43,0,0,0-1.5,1.33c0,.79.69,1.25,1.49,1.34a22.47,22.47,0,0,0,4.18-.11c1.38-.1,2.76-.21,4.14-.34s2.82-.28,4.23-.46a10.43,10.43,0,0,0,3.86-.89A1.28,1.28,0,0,0,346,688.1Z"
            fill="#f9f5ec"
          />
          <path
            d="M334.44,608.35a102.53,102.53,0,0,0-1.4,16.94c.14,5.34.66,10.69,1,16,.78,10.79,1.64,21.18,5,31.62.46,1.41,2.95.83,2.49-.58-3.45-10.61-4.24-21.23-5-32.19-.38-5.32-.94-10.66-1-16A107.64,107.64,0,0,1,337,608.36c.21-1.45-2.36-1.45-2.57,0Z"
            fill="#c4432d"
          />
        </g>
        <g>
          <path
            d="M429.47,357.78l4.94-.37.32,4.3-4.94.36a1.15,1.15,0,0,1-1.13-1.16l-.13-1.82A1.15,1.15,0,0,1,429.47,357.78Z"
            fill="#eda60a"
          />
          <g>
            <path
              d="M428.26,368.58a9.44,9.44,0,0,0,2.75-5.19l.05-.26a2.53,2.53,0,0,1,2.17-2.21l27.95-2.05a2.52,2.52,0,0,1,2.47,1.86l.09.26a9.34,9.34,0,0,0,3.48,4.73h0a3.16,3.16,0,0,1,1.26,2.36l3.78,51.4a3.12,3.12,0,0,1-.91,2.51h0a9.46,9.46,0,0,0-2.75,5.2l-.05.26a2.53,2.53,0,0,1-2.17,2.21l-27.95,2a2.54,2.54,0,0,1-2.47-1.86l-.09-.26a9.41,9.41,0,0,0-3.48-4.74h0a3.12,3.12,0,0,1-1.26-2.35l-3.78-51.4a3.15,3.15,0,0,1,.91-2.52Z"
              fill="url(#New_Pattern_Swatch_8-3)"
            />
            <path
              d="M428.26,368.58a9.44,9.44,0,0,0,2.75-5.19l.05-.26a2.53,2.53,0,0,1,2.17-2.21l6-.44a2.54,2.54,0,0,0-2.17,2.21l0,.26a9.41,9.41,0,0,1-2.76,5.2,3.14,3.14,0,0,0-.9,2.51l3.77,51.4a3.14,3.14,0,0,0,1.27,2.36h0a9.45,9.45,0,0,1,3.48,4.73l.08.26a2.52,2.52,0,0,0,2.47,1.86l-6,.44a2.54,2.54,0,0,1-2.47-1.86l-.09-.26a9.41,9.41,0,0,0-3.48-4.74h0a3.12,3.12,0,0,1-1.26-2.35l-3.78-51.4A3.15,3.15,0,0,1,428.26,368.58Z"
              fill="#9fa2a5"
            />
            <path
              d="M472.2,420.4a2.91,2.91,0,0,1-.85,1.59h0a9.46,9.46,0,0,0-2.75,5.2l-.05.26a2.53,2.53,0,0,1-2.17,2.21l-27.95,2a2.54,2.54,0,0,1-2.47-1.86l-.09-.26a9.41,9.41,0,0,0-3.48-4.74h0a2.91,2.91,0,0,1-1.07-1.44Z"
              fill="#e5ebf6"
            />
            <path
              d="M432.19,424.7l-.12-.11,0,0-.14-.15h0l-.12-.15,0,0-.11-.15v0a1.18,1.18,0,0,1-.11-.19h0a1.86,1.86,0,0,1-.1-.2v0a1.67,1.67,0,0,1-.08-.2l6-.44a3,3,0,0,0,1.08,1.45h0a9.45,9.45,0,0,1,3.48,4.73l.08.26a2.52,2.52,0,0,0,2.47,1.86l-6,.44a1.68,1.68,0,0,1-.39,0,1.8,1.8,0,0,1-.39-.08l-.18-.07a2.31,2.31,0,0,1-.35-.18l-.17-.12a2.81,2.81,0,0,1-.9-1.19l-.09-.22-.09-.25a10.37,10.37,0,0,0-.79-1.76,9.14,9.14,0,0,0-.62-.95l-.22-.3a9.14,9.14,0,0,0-1-1.06,7.82,7.82,0,0,0-.85-.67h0l-.16-.12Z"
              fill="#d1dced"
            />
            <path
              d="M429.79,362.07l35-2.57a1.15,1.15,0,0,0,.94-1.31l-.13-1.82a1.17,1.17,0,0,0-1.13-1.16l-35,2.57a1.15,1.15,0,0,0-.94,1.31l.13,1.82A1.15,1.15,0,0,0,429.79,362.07Z"
              fill="#ffbf14"
            />
            <ellipse
              cx={449.53}
              cy={391.54}
              rx={12.9}
              ry={20.82}
              transform="translate(-27.47 33.98) rotate(-4.2)"
              fill="#ffdc6c"
            />
            <path
              d="M448,370.77a8.43,8.43,0,0,1,3,.34c-5.52,2.57-9.14,11.11-8.42,20.94s5.55,17.75,11.39,19.49a8.42,8.42,0,0,1-2.92.77c-7.1.52-13.54-8.36-14.38-19.83S440.9,371.29,448,370.77Z"
              fill="#f7ce5e"
            />
            <path
              d="M437.29,398.21l25.32-1.86a2.39,2.39,0,0,0,1.95-2.72l-.47-6.35a2.38,2.38,0,0,0-2.32-2.41l-25.33,1.86a2.4,2.4,0,0,0-1.94,2.72l.47,6.35A2.38,2.38,0,0,0,437.29,398.21Z"
              fill="#fff"
            />
            <path
              d="M436.44,386.73l3.76-.28.84,11.48-3.75.28A2.38,2.38,0,0,1,435,395.8l-.47-6.35A2.4,2.4,0,0,1,436.44,386.73Z"
              fill="#f4f2ed"
            />
          </g>
        </g>
        <path
          d="M563.18,374.59c-3.68-7.47-8.67-14.23-12.51-21.63a150.78,150.78,0,0,1-9.18-21.78,155.18,155.18,0,0,1-7.81-49.25,3.83,3.83,0,0,0-.2-1.26c-.86-11.9-16.87-11.84-25-6.69-10.48,6.66-14.39,18.92-14.84,30.77-.2,5.48.76,12.33-2.65,17.07-3.65,5.08-9.8,6.68-10.82,13.64-.81,5.56,2.05,10.33,4.6,15,1.9,3.5,3.22,6.67,1.35,10.53-1.72,3.57-4.87,6.26-7.32,9.3-3.45,4.27-6.52,9.65-5.37,15.36,1.24,6.17,7.63,8.25,13.06,9.65a46,46,0,0,0,19.58.61c3-.52,5.89-1.36,8.9-1.6,4.76-.37,9.44.64,14,1.68,7.14,1.62,14.25,3.45,20.7,7,4.6,2.56,9.48,5.48,14.8,3C575.43,401,566.84,382,563.18,374.59Z"
          fill="#dbc3a1"
        />
        <path
          d="M492.86,691.25H655.14s-.13,156.1,0,208.14c.13,53,4.84,62.69.86,69.61,0,0-44.67,2.45-73-2,0,0,.23-49-2.22-67.61-3.77-28.73-17.36-114.66-17.36-114.66l-1.48,114.66L557,967.45c-24.74,5.51-62,2.9-62,2.9-4.47-19.93-1.06-20.86-8.11-71-10.47-74.38-9.77-208.14-9.77-208.14Z"
          fill="#694c51"
        />
        <path
          d="M538.58,768.46A177.63,177.63,0,0,1,525,816c-6.46,14.27-14.83,28.88-25.74,37-6.23,4.66-13.45,7-20.66,5.8a3.09,3.09,0,0,1-2.13-3.11l-.15-4c-.07-1.88,1.06-3.32,2.42-3.17,11.11,1.22,22-13.27,28.88-23.63,7.55-11.31,9.06-18,13.36-32.22,2.44-8.07,3.76-18.7,5-27.32.92-6.4,13.48-3.38,12.55,3.06Z"
          fill="#382632"
        />
        <path
          d="M616.12,783.35A142.87,142.87,0,0,0,627,821.51c5.18,11.46,11.91,23.19,20.66,29.74,5,3.74,10.81,5.64,16.6,4.66a2.5,2.5,0,0,0,1.71-2.5l.12-3.18c0-1.51-.85-2.67-2-2.55-8.92,1-17.63-10.66-23.19-19-6.06-9.08-7.27-14.43-10.73-25.87-2-6.49-3-15-4-22-.74-5.14-10.82-2.71-10.08,2.46Z"
          fill="#382632"
        />
        <path
          d="M404.88,549.48s23.11.38,36.84-12.61a8.36,8.36,0,0,0,2.55-6.18L444,500.26c6.37-12.6,13.19-28.75,27.1-43.23,12.25-12.75,23.93-22.56,36.05-27h0c21-8,30-11,30-11,38.95,21.65,78.4-.46,78.4-.46,5.41.55,21.7,8,21.7,8s28.92,12,63.41,46.23h0c40,30.82,76,71.43,75.85,104.25-.07,18.43-23.32,53.73-23.32,53.73-19.36-5.83-41.88-22.13-41.88-22.13,5.77-11.91,11-27.09,11-27.09-6.39-6.26-52.66-41.12-52.66-41.12-25.52,34.55-4,226.7-4,226.7-9.55,11.89-32.58,15.7-46.36,16.92-42.72,6-74.13,5.2-95.45,2.6-8.83,0-19.06-2.53-28.49-5.67a60.46,60.46,0,0,1-6.93-2.47,223.26,223.26,0,0,1-23.1-10.25C485.69,710.73,475.91,551,475.91,551c-4.39,13.48-26.29,52.2-57.37,42.51C404.9,589.29,404,566.4,404.88,549.48Z"
          fill="#13a89e"
        />
        <path
          d="M615.51,418.54s-41.45,22.11-78.4.46c0,0,17.63-2.71,17.81-12.86l0-24.57L566.11,373l31.15,13.5S583.92,416.09,615.51,418.54Z"
          fill="#d69b6d"
        />
        <path
          d="M549.6,904.41c-9-3.32-19.18-3-28.47-2.75-9.44.21-19.46-.16-28.64,3-.66.23-.38,1.55.28,1.32,9.07-3.12,19-2.73,28.36-2.94s19.27-.58,28.19,2.69c.66.24.94-1.07.28-1.31Z"
          fill="#5b3f45"
        />
        <path
          d="M555.11,389.5v5.37c23.69.06,33.57-28.48,33.57-28.48C580.51,368.13,555.11,389.5,555.11,389.5Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M600.46,341.71c0-.17-1.72-5.85-1.75-8.23-.45-30.38-19.61-52.35-42.61-54.38-14.53-1.29-25-1.71-31.29,6-5.26,6.44-7.4,19.73-7.75,32-.33,11.39-5.42,16.2-10.37,22.12a3.53,3.53,0,0,0,3.63,5.51l4-.43a1.68,1.68,0,0,1,1.84,1.41,80.51,80.51,0,0,0,6.21,21.64c6.35,13.44,14.34,25.55,35.4,21.77,23.42-4.19,37.52-25.8,42.51-33.67A111,111,0,0,0,600.46,341.71Z"
          fill="#d69b6d"
        />
        <path
          d="M530.68,329.36a2.4,2.4,0,1,1-2.37-2.81A2.61,2.61,0,0,1,530.68,329.36Z"
          fill="#382632"
        />
        <path
          d="M517.44,281.45a24.52,24.52,0,0,0-12.78,13.68,23.8,23.8,0,0,0-1.61,9.48c.15,3.95,1.86,7.68,1.8,11.64a16.21,16.21,0,0,1-4.36,10.7c-2.3,2.48-5.2,4.59-6.69,7.71-1.68,3.5-.94,7.3.09,10.88,1.18,4.08,2.2,7.94,1.89,12.24-.68,9.51-5.9,18.13-10.79,26.05a.75.75,0,0,0,1.3.76c4.22-6.84,8.48-14,10.26-21.93a29.09,29.09,0,0,0,.38-11.53c-.72-4-2.69-7.84-2.66-11.95s2.71-6.68,5.41-9.29a20.88,20.88,0,0,0,5.8-8.47,19.8,19.8,0,0,0,0-11,24.85,24.85,0,0,1-.62-10.64,23.31,23.31,0,0,1,13.3-17c.88-.39.12-1.68-.76-1.3Z"
          fill="#e8ceaf"
        />
        <path
          d="M508.75,362a42.93,42.93,0,0,1-12,26.27c-.68.7.38,1.76,1.06,1.07A44.61,44.61,0,0,0,510.25,362c.08-1-1.42-.95-1.5,0Z"
          fill="#e8ceaf"
        />
        <g>
          <path
            d="M640.14,380.77c-3.23-3.41-8-5.68-9.86-10.18-3.8-9.34,3.4-19.52-1.94-28.87-2.18-3.83-4.76-5.63-4.47-10.37.26-4.11,1.53-8.12,2-12.22A21,21,0,0,0,624.53,308c-1.91-4.29-6.07-6.48-8.47-10.32-3.81-6.11-3.15-14.07-7.2-20.21a18.88,18.88,0,0,0-11.46-7.75c-2.71-.71-5.63-.87-8.18-2.11-2.31-1.13-4.16-3-6.11-4.64a50.5,50.5,0,0,0-29.58-11.91c-10-.57-21.19,2.21-27.41,10.51-5.59,7.48-5.4,18.55,1.63,25a5.83,5.83,0,0,0,1.77,1.15,21.47,21.47,0,0,0,14.72,7.87c3,.28,12.09-2.27,14.38.29,1.16,1.28.2,3.41.18,5a11.22,11.22,0,0,0,1.76,6.69c2.43,3.48,6,4,10,4.56,5.94.82,2.55,4.65,1.58,8.51a11.45,11.45,0,0,0,2.67,10.22c2,2.44,6.46,4.63,6.28,8.13-.23,4.45-4.6,8.86-6,13.06-1.71,5.15-1.3,10.76-2.79,16-1.34,4.72-3,9.42-3.12,14.37-.13,5.29,2.67,9.69,3.18,14.78.89,8.78-8.75,17.53-4.79,26.12,3.69,8,14.69,6.55,21.28,3.61s12-8.34,17.55-13a34.41,34.41,0,0,1,8.79-5.71c4.74-1.9,9.84-.79,14.79-1.26,8-.77,16.21-6,15.73-14.88C645.45,387.83,643.09,383.89,640.14,380.77Z"
            fill="#dbc3a1"
          />
          <path
            d="M549.67,278.28a19.52,19.52,0,0,0,11.86,8.2c2.27.52,5.07.76,6.74,2.58s1.35,4.74,1.21,7.11c-.13,2.22-.13,4.56,1.07,6.52a10.66,10.66,0,0,0,4.07,3.55c3.29,1.8,8.08,3,9.13,7.14.64,2.51-.13,5.18-.46,7.68a11.16,11.16,0,0,0,.91,7c1.19,2.21,3.17,3.83,4.59,5.88a14.53,14.53,0,0,1,2.43,7.67c.29,6-2.08,11.54-4,17.08a50.73,50.73,0,0,0-2.66,17.71c.22,12.28,3.1,26.38-5,37-.58.77.72,1.52,1.3.76,6.94-9.14,6-21.23,5.4-32-.37-6.38-.55-12.84,1.13-19.07,1.54-5.7,4.24-11.07,5-17,.72-5.31-.19-10.42-3.71-14.57-1.8-2.12-3.89-4.12-4.16-7-.23-2.56.53-5.09.77-7.63a9.11,9.11,0,0,0-1.39-6.38,12,12,0,0,0-4.33-3.39c-3.57-1.86-8.28-3.25-8.71-7.94-.26-2.73.53-5.51-.11-8.21A6.85,6.85,0,0,0,566,286c-2.74-.93-5.61-1.12-8.23-2.44a18,18,0,0,1-6.84-6.07c-.54-.8-1.84,0-1.3.76Z"
            fill="#e8ceaf"
          />
          <path
            d="M591.82,291.76c-1.69,8.37,9.58,10.59,11.43,17.53,1,3.81-.28,7.85-.81,11.64a19.78,19.78,0,0,0,1.41,10.74c1.5,3.57,3.63,7.08,3.8,11s-1.49,7.83-2.93,11.49A35.79,35.79,0,0,0,602,366.3a104.46,104.46,0,0,0,.94,13.45c.8,8,.88,17.43-5.43,23.37-.7.67.36,1.73,1.06,1.06,5.19-4.89,6.44-12.32,6.25-19.16-.24-8.83-2.78-17.72-.06-26.41,1.22-3.9,3.17-7.58,4-11.6a17.66,17.66,0,0,0-1.22-10.77c-1.51-3.64-3.67-7.18-3.84-11.22s1.14-7.75,1.39-11.66a12.76,12.76,0,0,0-.82-5.77,13.51,13.51,0,0,0-3.79-4.86c-3.07-2.66-8.16-5.79-7.19-10.58.19-.94-1.26-1.34-1.45-.39Z"
            fill="#e8ceaf"
          />
          <path
            d="M618.36,367.05c2.41,1.33,3,4.24,3,6.78,0,3-.41,5.87.53,8.76a30.59,30.59,0,0,0,3.47,7,8.32,8.32,0,0,0,4.94,4c.94.22,1.34-1.22.4-1.44-2.45-.57-3.82-2.82-5-4.88-1.46-2.64-2.88-5.33-3-8.42-.17-4.44,1.17-10.45-3.6-13.08-.84-.47-1.6.82-.75,1.29Z"
            fill="#e8ceaf"
          />
        </g>
        <line
          x1={614.24}
          y1={530.95}
          x2={614.24}
          y2={537.53}
          fill="#ddb292"
          opacity={0.5}
        />
        <line
          x1={523.4}
          y1={537.53}
          x2={523.4}
          y2={530.95}
          fill="#ddb292"
          opacity={0.5}
        />
        <path
          d="M736.84,624.09c3.21,1.55,12.42,5.41,12.42,5.41-26,28.76-67.35,63.47-78.63,70.21-2.22,1.33-8.58,3.24-13.13-1.59-2.75-2.92-2.31-7.76-4.18-8.22-4.06-1-17.06,16.36-20.88,13.48-4.12-3.1,14.69-17.71,13-20.29s-23,13.9-24.43,8.77c-1.17-4.24,18.57-14.54,17.79-15.79s-20.45,13.62-21.92,9.52c-2-5.56,21.57-16.48,21-17.7-1.63-3.52-21.66,14-23.14,8.81-1-3.38,13.94-16.71,23.3-17,14.28-.49,23.53,14.69,29.17,13.2,2.59-.69,20.22-19.63,47.68-61.67,0,0,5.9,3.85,6.66,4.3,1.61,1,2.07,1.29,3.54,2.16.66.39,1.52.93,2.81,1.64C729.82,620.32,732.45,622,736.84,624.09Z"
          fill="#d69b6d"
        />
        <path
          d="M721.2,588.1c11.4,6.34,23.09,12.45,35.78,15.81a.59.59,0,0,0,.31-1.14c-12.59-3.34-24.18-9.39-35.5-15.69-.66-.37-1.26.65-.59,1Z"
          fill="#1ec6b6"
        />
        <path
          d="M723.32,581.37a34.33,34.33,0,0,1,8.95-11.89c4.07-3.42,9.14-5,14.3-5.85.75-.13.43-1.27-.31-1.14-5.26.91-10.37,2.51-14.56,5.93a35.07,35.07,0,0,0-9.4,12.35c-.32.69.7,1.29,1,.6Z"
          fill="#1ec6b6"
        />
        <path
          d="M646.61,510.92a155.39,155.39,0,0,0,10.69,15.15c2,2.52,3.92,5,5.88,7.53a60.5,60.5,0,0,0,6.07,6.92c.55.52,1.39-.31.83-.84a59,59,0,0,1-6-6.77l-5.77-7.38a157.69,157.69,0,0,1-10.73-15.2.59.59,0,0,0-1,.59Z"
          fill="#1ec6b6"
        />
        <path
          d="M648.83,540.37c3,1.25,6.36,1.17,9.58,1.15,3.53,0,7.07-.16,10.59-.41.75-.05.76-1.24,0-1.18q-5.1.36-10.2.41c-3.24,0-6.61.15-9.66-1.11-.7-.29-1,.85-.31,1.14Z"
          fill="#1ec6b6"
        />
        <path
          d="M404.88,549.48s37.68,15.22,39.43-15.36c3.38-59.06-8.47-76.24-4.52-82,7-10.15,10.44-19.51,12.73-22.38a77.23,77.23,0,0,1,7.61-7.92c2.33-1.92,2.94-5.19.23-5.73-1.89-.38-4.85,1.33-5.14.89-.46-.67,5.88-4.25,6.3-7.27.66-4.7-3.72-4.19-3.72-4.19,1.41-1.74,1.73-3.68.93-4.49-4.46-4.54-18.87,5-19.59,4.26-1.79-1.93,20.3-19.84,18.46-24.26-1.72-4.14-18.42,7.65-26.33,21.12C419.86,421.58,404.87,505,404.88,549.48Z"
          fill="#d69b6d"
        />
        <path
          d="M477.58,514a290.48,290.48,0,0,1-1.84,36.23c-.09.75,1.09.75,1.18,0A292.42,292.42,0,0,0,478.77,514a.6.6,0,0,0-1.19,0Z"
          fill="#1ec6b6"
        />
        <path
          d="M406.92,569.94c12.81-.37,26.11-3.37,36.27-11.58.59-.48-.25-1.31-.84-.84-9.89,8-23,10.88-35.43,11.23-.76,0-.77,1.21,0,1.19Z"
          fill="#1ec6b6"
        />
        <path
          d="M660.62,448.68A37.33,37.33,0,0,0,650,474.49a.59.59,0,0,0,1.18,0,36.19,36.19,0,0,1,10.28-25c.53-.54-.3-1.38-.83-.83Z"
          fill="#1ec6b6"
        />
        <g
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        >
          <path
            d="M446.34,412c1.77-1.06,3.51-2.24,5.37-3.14s3.9-1.83,5.85-2.74c.68-.32.09-1.34-.6-1-1.95.91-3.92,1.79-5.85,2.74s-3.6,2.08-5.36,3.15a.59.59,0,0,0,.59,1Z"
            fill="#9e695c"
          />
        </g>
        <g
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        >
          <path
            d="M450.58,420.35c.7-.5,1.39-1,2.12-1.45a21.89,21.89,0,0,1,2.26-1.16.59.59,0,0,0,.21-.81.6.6,0,0,0-.8-.21,21.07,21.07,0,0,0-2.27,1.16c-.72.45-1.42.95-2.11,1.45a.6.6,0,0,0-.21.81.58.58,0,0,0,.8.21Z"
            fill="#9e695c"
          />
        </g>
        <path
          d="M583.87,769.67c19.78-.75,40.08-2.62,58.87-7.52a138,138,0,0,0,14.87-4.79c.9-.35.11-1.37-.79-1-17.19,6.69-36.55,9.52-55.64,11.11q-8.64.72-17.31,1c-1,0-1,1.22,0,1.18Z"
          fill="#1ec6b6"
        />
        <path
          d="M666.36,674c1.33,1.3,2.72,2.58,4,3.94a14.11,14.11,0,0,1,2.6,4.45.59.59,0,0,0,.81.21.6.6,0,0,0,.21-.8,15,15,0,0,0-2.68-4.59c-1.3-1.4-2.74-2.71-4.11-4.05-.54-.53-1.38.3-.83.84Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M444.74,534.11c2.15,4.59,2.94,9.64,3.45,14.64.55,5.32.82,10.67.84,16a.59.59,0,0,0,1.18,0A161.19,161.19,0,0,0,449.3,548a45.38,45.38,0,0,0-3.54-14.53c-.33-.69-1.35-.09-1,.6Z"
          fill="#1ec6b6"
        />
        <path
          d="M633.77,718.7a69.93,69.93,0,0,1,16.63-15.29c.63-.42,0-1.44-.6-1a71.38,71.38,0,0,0-16.87,15.47c-.47.59.37,1.44.84.84Z"
          fill="#1ec6b6"
        />
        <g
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        >
          <path
            d="M431.63,455.83c2.35.19,4.87.28,6.94-1.05.63-.42,0-1.44-.6-1-1.88,1.22-4.2,1.06-6.34.89-.76-.07-.75,1.12,0,1.18Z"
            fill="#9e695c"
          />
        </g>
        <path
          d="M712.61,486.5s-1.22,32-30.61,58.51"
          fill="none"
          stroke="#f9f5ec"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M730.15,504S728,527.8,697.3,555.65"
          fill="none"
          stroke="#f9f5ec"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M655.59,549.27s-148.38,12.6-174.18-10.09"
          fill="none"
          stroke="#f9f5ec"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M655.59,569.94s-112.38,17.88-174.18-6.28"
          fill="none"
          stroke="#f9f5ec"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M472.86,539.18S455.28,530.5,447.44,519"
          fill="none"
          stroke="#f9f5ec"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M522.11,359.89s3.89,1.11,8-2.89"
          fill="none"
          stroke="#9e695c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M524.25,316.22c-.63-1.57,0-2.17,2.53-2.54a21.5,21.5,0,0,1,7.9.69c5.26,1.5,9.38,5.95,7.88,5.18A31.13,31.13,0,0,0,531.28,316C528.35,315.64,524.4,316.58,524.25,316.22Z"
          fill="#513715"
        />
        <path
          d="M216.6,420,282,437c23.84,33.75,43.12,49.05,51.29,136.17C339.6,641,326.6,764.3,325.6,794c0,0-54.82,10-84-6C216.85,774.39,276.89,654.81,262,578.75,247.68,505.53,219.1,471.79,216.6,420Z"
          fill="#a02410"
        />
        <g clipPath="url(#clip-path-2)">
          <path
            d="M217,420s-33.61,1.67-48.53,11.11c-64.88,41-102.21,157.39-85.6,181.89,21.8,32.14,80.53,50.11,80.53,50.11,8.45,79.12-13.51,140.78-13.51,140.78,10.57,10.18,43.58,1.13,73.2,9.3,52.19,14.38,100,10.67,100,10.67-8.87-30.62-26.85-61.55-25.13-109.5,3.09-86.72,7.56-90.67-11.83-174.29C278.15,505.63,270.5,475.58,217,420Z"
            fill="#f15931"
          />
          <path
            d="M222.73,422.32c9.34,31.7,18.73,63.52,24.09,96.19,5.59,34,7.87,68.83,10.78,103.18,5.72,67.42,8.66,135.43-.68,202.67-.2,1.46,2,2.09,2.23.62,9.37-67.46,6.5-135.64.77-203.29-2.84-33.52-5.17-67.38-10.36-100.63-5.27-33.77-14.95-66.63-24.6-99.35a1.16,1.16,0,0,0-2.23.61Z"
            fill="#f9f5ec"
          />
          <path
            d="M135.48,456.08c8.93,7.58,19.49,12.69,30.58,16.31,6.13,2,12.4,3.56,18.68,5,6.1,1.38,12.21,2.63,18.5,2.53a1.16,1.16,0,0,0,0-2.32c-11.76.19-24.24-3.52-35.37-7s-21.81-8.51-30.76-16.1c-1.13-1-2.77.67-1.63,1.64Z"
            fill="#f9f5ec"
          />
          <path
            d="M106.34,498a125.78,125.78,0,0,0,80.13,42.47c1.47.17,1.46-2.14,0-2.32A123.44,123.44,0,0,1,108,496.34c-1-1.13-2.61.51-1.64,1.63Z"
            fill="#f9f5ec"
          />
          <path
            d="M79.74,559.24c10.86,8.64,23.91,13.51,37.58,15.47a136.92,136.92,0,0,0,21.8,1.15c7.72-.13,15.56-.37,22.81,2.71,1.36.58,2.54-1.42,1.17-2-12.31-5.22-26.29-2.32-39.27-3.43-15.27-1.3-30.34-5.9-42.46-15.54-1.15-.92-2.8.71-1.63,1.64Z"
            fill="#f9f5ec"
          />
          <path
            d="M84.16,618.1c6.93-10.24,17.51-17,28.52-22.16a163,163,0,0,1,38.84-12.46c1.47-.28.85-2.51-.61-2.23a164.52,164.52,0,0,0-40.39,13.16c-11,5.3-21.41,12.25-28.36,22.52-.84,1.23,1.16,2.39,2,1.17Z"
            fill="#f9f5ec"
          />
          <path
            d="M125.81,650c2.32-2.42,5.13-4.16,7.79-6.18a67,67,0,0,0,7.3-6.59c5.21-5.34,10.17-10.94,15.07-16.56,8.69-10,18.33-20.21,22.83-32.88.5-1.4-1.74-2-2.23-.61-4.6,12.94-14.86,23.47-23.77,33.61-4.53,5.15-9.1,10.3-13.91,15.19-4.54,4.61-10.28,7.76-14.72,12.39-1,1.07.61,2.71,1.64,1.63Z"
            fill="#f9f5ec"
          />
          <path
            d="M177.11,670.26c9.12-7.92,16.85-17.63,24.13-27.23q5.56-7.32,10.63-15c1.74-2.62,3.44-5.26,5-8,1.28-2.23,3-4.74,3.43-7.32.24-1.46-2-2.09-2.23-.62-.45,2.7-2.36,5.34-3.73,7.67-1.51,2.56-3.12,5.05-4.76,7.52q-5,7.44-10.35,14.56c-7.16,9.44-14.8,19-23.77,26.76-1.13,1,.52,2.61,1.64,1.64Z"
            fill="#f9f5ec"
          />
          <path
            d="M193.42,441.64c-15.37,17.36-22.15,40-29.61,61.53-8.92,25.71-15.28,51.41-13.32,78.84.11,1.48,2.42,1.49,2.32,0-1.88-26.25,3.9-51,12.36-75.71,7.5-21.88,14.25-45.37,29.89-63,1-1.11-.65-2.76-1.64-1.64Z"
            fill="#f9f5ec"
          />
          <path
            d="M158.06,433.67c-22.84,25-37.76,58.46-48.72,90.2a354.84,354.84,0,0,0-19.1,104.3c0,1.49,2.26,1.49,2.31,0a353.22,353.22,0,0,1,18.07-100.89c10.82-32.22,25.93-66.61,49.07-92,1-1.1-.63-2.74-1.63-1.64Z"
            fill="#f9f5ec"
          />
          <path
            d="M93.6,630.54c7.32,6.27,18.2,8.36,27.2,11.21,11.69,3.7,23.51,6.94,35.4,9.93,24.17,6.08,48.53,11.45,72.81,17.07,1.45.33,2.07-1.9.61-2.24-22.56-5.22-45.18-10.26-67.68-15.79-11.11-2.73-22.18-5.64-33.14-8.93q-7.4-2.22-14.74-4.67c-6.33-2.11-13.68-3.81-18.83-8.21-1.12-1-2.77.66-1.63,1.63Z"
            fill="#f9f5ec"
          />
          <path
            d="M152,583.19c9.84,11.49,23.19,18.72,36.49,25.47a208.44,208.44,0,0,0,21.57,9.84c8.2,3,17.2,4.16,24.9,8.45a1.16,1.16,0,0,0,1.16-2c-6.61-3.69-14-4.91-21.17-7.2-8.31-2.67-16.17-6.49-23.95-10.41-13.57-6.85-27.32-14.06-37.37-25.79-1-1.13-2.6.52-1.63,1.64Z"
            fill="#f9f5ec"
          />
          <path
            d="M162.5,578.07a45.63,45.63,0,0,0-29.85,22.44c-.61,1.12,1.1,2.13,1.72,1A43.65,43.65,0,0,1,163,580c1.24-.28.72-2.2-.53-1.92Z"
            fill="#c4432d"
          />
          <path
            d="M212.85,685c-.19,41.9-2.49,84.85-15.08,125.15-.45,1.43,1.78,2,2.23.62,12.65-40.48,15-83.69,15.17-125.77a1.16,1.16,0,0,0-2.32,0Z"
            fill="#f9f5ec"
          />
          <path
            d="M310.89,828.79c3.49-14,4.95-28.26,5.49-42.64.05-1.49-2.26-1.49-2.32,0-.52,14.18-2,28.23-5.4,42a1.16,1.16,0,0,0,2.23.61Z"
            fill="#f9f5ec"
          />
          <path
            d="M220.54,611.67c-2.84-37.07-5.85-74.44-17.24-110-.46-1.41-2.69-.81-2.24.62,11.33,35.42,14.34,72.56,17.17,109.43.11,1.47,2.43,1.49,2.31,0Z"
            fill="#f9f5ec"
          />
          <path
            d="M202.39,459.17q11-1.41,21.89-3.24c6.66-1.12,13.52-2.07,19.62-5.15,1.33-.67.16-2.67-1.17-2-5.89,3-12.63,3.83-19.06,4.92q-10.6,1.79-21.28,3.16c-1.46.18-1.48,2.5,0,2.31Z"
            fill="#f9f5ec"
          />
          <path
            d="M196.79,519.72c27-3.51,54.51-5.1,80.38-14.22,1.4-.49.8-2.73-.61-2.23-25.69,9.05-53,10.65-79.77,14.13-1.46.19-1.48,2.51,0,2.32Z"
            fill="#f9f5ec"
          />
          <path
            d="M173.57,563.79c20.86,1.56,41.75.67,62.52-1.61,9.13-1,18.31-2.06,27.34-3.77,9.19-1.74,17.71-5,26.26-8.75,1.37-.59.19-2.59-1.17-2-18.4,8-37.09,10.69-57,12.68a331.39,331.39,0,0,1-58,1.13c-1.49-.11-1.48,2.21,0,2.32Z"
            fill="#f9f5ec"
          />
          <path
            d="M210.79,607.18c6.7,1.05,13.86.18,20.59-.34,7-.53,14-1.33,21-2.3,15.13-2.1,30.11-5,45.09-8,1.46-.29.84-2.52-.61-2.24-13.89,2.72-27.79,5.44-41.8,7.5-7.3,1.07-14.62,1.95-22,2.56-7,.57-14.67,1.64-21.62.55-1.46-.23-2.09,2-.62,2.23Z"
            fill="#f9f5ec"
          />
          <path
            d="M243.48,653.73c9.94.31,19.91.85,29.87.87,4.63,0,9.23-.54,13.87-.59,4.47,0,8.9,0,13.31-.91,1.45-.3.84-2.53-.62-2.23-4.72,1-9.48.72-14.26.85-4.48.12-8.93.6-13.41.55-9.59-.11-19.18-.56-28.76-.86a1.16,1.16,0,0,0,0,2.32Z"
            fill="#f9f5ec"
          />
          <path
            d="M160.58,691.62c45.06,11.09,93,12.35,138.9,5.07,1.47-.23.85-2.46-.61-2.23-45.4,7.2-93.09,5.9-137.67-5.08-1.45-.35-2.06,1.88-.62,2.24Z"
            fill="#f9f5ec"
          />
          <path
            d="M158.46,738c22.76,4.77,45.58,10.7,68.91,11.72,25.19,1.1,50.78-2.16,75.91-3.87,1.48-.1,1.49-2.41,0-2.31-24.27,1.65-48.92,4.7-73.26,4-24-.73-47.51-6.82-70.94-11.73-1.46-.3-2.08,1.93-.62,2.23Z"
            fill="#f9f5ec"
          />
          <path
            d="M151,782.36c11.83,5.73,24.1,10.91,37.21,12.8,15.47,2.23,31.12,2,46.63,4.42,28.24,4.49,56.38,10.88,85,5.88,1.46-.26.84-2.49-.62-2.24-29.25,5.12-58.05-2-86.9-6.36-12.67-1.93-25.27-2.29-38-3.35-15-1.25-28.73-6.64-42.16-13.15-1.33-.65-2.51,1.35-1.17,2Z"
            fill="#f9f5ec"
          />
          <path
            d="M164.63,665.08c19.72,10.6,41.23,19.21,63.3,23.34,1.25.23,1.78-1.68.53-1.92-21.91-4.1-43.25-12.61-62.83-23.14-1.12-.6-2.13,1.11-1,1.72Z"
            fill="#c4432d"
          />
          <path
            d="M162.52,579.89a349.58,349.58,0,0,1,46.09,26,254.32,254.32,0,0,1,21.78,16.47c6.9,5.86,14.14,11.95,18.33,20.13.58,1.13,2.3.13,1.71-1-3.93-7.68-10.45-13.45-16.89-19a255.24,255.24,0,0,0-21.4-16.54,344.43,344.43,0,0,0-48.62-27.72c-1.15-.54-2.16,1.17-1,1.72Z"
            fill="#c4432d"
          />
          <path
            d="M174,430.49c14.41,4.52,23.53,12.89,27.05,27.76,3.23,13.65,2.12,28.72-.56,42.35-5.75,29.33-23.13,53.13-38.57,78.09-.67,1.09,1,2.09,1.72,1,9.4-15.2,19.91-30.17,28-46.12,6.82-13.42,10.8-28.57,12.46-43.49,1.48-13.33,1.54-28.07-3.83-40.64-4.94-11.56-14.13-17.22-25.75-20.86-1.22-.39-1.74,1.53-.53,1.91Z"
            fill="#c4432d"
          />
        </g>
        <g>
          <path
            d="M302.87,610.31l5.39,1.64-1.42,4.7-5.4-1.64a1.33,1.33,0,0,1-.72-1.7l.61-2A1.32,1.32,0,0,1,302.87,610.31Z"
            fill="#eda60a"
          />
          <g>
            <path
              d="M297.15,621.3a10.78,10.78,0,0,0,5.06-4.39l.16-.26a2.88,2.88,0,0,1,3.2-1.46l30.55,9.27a2.87,2.87,0,0,1,1.85,3v.31a10.8,10.8,0,0,0,1.76,6.46h0a3.54,3.54,0,0,1,.38,3l-17,56.17a3.58,3.58,0,0,1-2,2.3h0A10.78,10.78,0,0,0,316,700.1l-.16.26a2.88,2.88,0,0,1-3.2,1.46l-30.55-9.27a2.88,2.88,0,0,1-1.85-3v-.31a10.8,10.8,0,0,0-1.76-6.46h0a3.55,3.55,0,0,1-.38-3l17-56.17a3.58,3.58,0,0,1,2-2.3Z"
              fill="url(#New_Pattern_Swatch_8-5)"
            />
            <path
              d="M297.15,621.3a10.78,10.78,0,0,0,5.06-4.39l.16-.26a2.88,2.88,0,0,1,3.2-1.46l6.53,2a2.89,2.89,0,0,0-3.21,1.46l-.16.26a10.71,10.71,0,0,1-5.05,4.39,3.55,3.55,0,0,0-2,2.3l-17,56.17a3.51,3.51,0,0,0,.38,3h0a10.73,10.73,0,0,1,1.75,6.46v.31a2.88,2.88,0,0,0,1.86,3l-6.53-2a2.88,2.88,0,0,1-1.85-3v-.31a10.8,10.8,0,0,0-1.76-6.46h0a3.55,3.55,0,0,1-.38-3l17-56.17A3.58,3.58,0,0,1,297.15,621.3Z"
              fill="#9fa2a5"
            />
            <path
              d="M322.62,694.37a3.39,3.39,0,0,1-1.55,1.34h0A10.78,10.78,0,0,0,316,700.1l-.16.26a2.88,2.88,0,0,1-3.2,1.46l-30.55-9.27a2.87,2.87,0,0,1-1.85-3v-.31a10.8,10.8,0,0,0-1.76-6.46h0a3.33,3.33,0,0,1-.55-2Z"
              fill="#e5ebf6"
            />
            <path
              d="M278.35,682.54a.8.8,0,0,1-.08-.16l0,0-.09-.22h0a1.72,1.72,0,0,1-.07-.21v0a1.6,1.6,0,0,1-.05-.21v0c0-.08,0-.17,0-.25h0c0-.08,0-.17,0-.25v-.29l6.53,2a3.26,3.26,0,0,0,.55,2h0a10.73,10.73,0,0,1,1.75,6.46v.31a2.88,2.88,0,0,0,1.86,3l-6.53-2a3,3,0,0,1-.41-.17,1.85,1.85,0,0,1-.37-.25l-.17-.14a3.17,3.17,0,0,1-.3-.34l-.13-.19a3.38,3.38,0,0,1-.47-1.64,1.13,1.13,0,0,1,0-.26v-.31a12.28,12.28,0,0,0-.13-2.2,10.42,10.42,0,0,0-.26-1.26l-.12-.41a10.36,10.36,0,0,0-.63-1.54,8.51,8.51,0,0,0-.62-1.05h0l-.12-.19Z"
              fill="#d1dced"
            />
            <path
              d="M301.44,615l38.21,11.59a1.3,1.3,0,0,0,1.54-1l.61-2a1.33,1.33,0,0,0-.72-1.7l-38.21-11.6a1.32,1.32,0,0,0-1.54,1l-.61,2A1.33,1.33,0,0,0,301.44,615Z"
              fill="#ffbf14"
            />
            <ellipse
              cx={310.35}
              cy={654.41}
              rx={23.71}
              ry={14.69}
              transform="translate(-405.97 761.4) rotate(-73.12)"
              fill="#ffdc6c"
            />
            <path
              d="M317.24,631.71a9.56,9.56,0,0,1,3.05,1.59c-6.92.47-14.27,8.07-17.53,18.8s-1.37,21.14,4.12,25.38a9.6,9.6,0,0,1-3.41-.38c-7.76-2.36-11-14.42-7.17-27S309.48,629.36,317.24,631.71Z"
              fill="#f7ce5e"
            />
            <path
              d="M294.61,656.48l27.68,8.4a2.72,2.72,0,0,0,3.18-2.1l2.1-6.94a2.71,2.71,0,0,0-1.48-3.5l-27.67-8.4a2.71,2.71,0,0,0-3.18,2.09L293.13,653A2.72,2.72,0,0,0,294.61,656.48Z"
              fill="#fff"
            />
            <path
              d="M298.42,643.94l4.1,1.24-3.8,12.54-4.11-1.24a2.72,2.72,0,0,1-1.48-3.51l2.11-6.94A2.71,2.71,0,0,1,298.42,643.94Z"
              fill="#f4f2ed"
            />
          </g>
        </g>
        <path
          d="M236.22,432c8.48,3.54,44.46,17.27,45.8,4.77l-1.6-69.7-54.66,2.25s.26,4.29.33,11.94c.1,11.92-4.79,25.14-9.31,38.89C216.31,421.6,234.83,431.44,236.22,432Z"
          fill="#dba795"
        />
        <path
          d="M281.38,409l-.22-9.76S248.52,395,239.07,382.1C239.07,382.1,244.22,403.73,281.38,409Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M227.33,369.27s12.49-.61,16-12c0-.15,15.52-62.53,37.51-62.75,26.06-.26,37.18,7.71,39.89,33.19,1.16,10.8,6.35,15,11.49,20.25a3.36,3.36,0,0,1-3,5.5l-3.79-.12a1.61,1.61,0,0,0-1.65,1.48c-1.15,14.48-7.86,34.61-12.44,38.18-2.85,2.22-13.73,5.49-23.88,6.13C248.55,401.62,227.33,369.27,227.33,369.27Z"
          fill="#dba795"
        />
        <path
          d="M311.59,341.29a2,2,0,0,1-3.16.55,3.05,3.05,0,0,1-.53-3.77,2,2,0,0,1,3.16-.54A3,3,0,0,1,311.59,341.29Z"
          fill="#382632"
        />
        <path
          d="M210.54,277.62c10.51-14.78,28.76-21.36,52.14-18.78,0,0,25.59,4.28,35.25,4.47.23,0,7.62,31.25,7.62,31.25A57.83,57.83,0,0,0,289,305c-6.73,6-11.22,19.18-12,25.83-.25,2.28-.39,5.32-.45,7.44v.43c-5.8,9-10,.42-10.15.45,0-1.18,0-2.29,0-3.56-.05-.12,0-.26-.06-.38s-10.57,4.42-11.36,10.7c-2.39,18.81-17.71,36.6-27.19,36.6-20.84,0-19-29.76-28.41-54.24C191.89,308.7,200.07,292.34,210.54,277.62Z"
          fill="#061a47"
        />
        <path
          d="M245.6,339.72A10.1,10.1,0,0,0,257.42,348a10.83,10.83,0,0,0,9.08-11.57c-.38-6.05-5.07-10.78-10.46-10.34C246.18,326.86,244.6,334,245.6,339.72Z"
          fill="#dba795"
        />
        <path
          d="M254,337.71a2.6,2.6,0,0,1,1.7-2,3.68,3.68,0,0,1,1.4-.18,6.62,6.62,0,0,0-2.19-2.65c-.48-.35,0-1.15.48-.79a7.6,7.6,0,0,1,2.69,3.33,9,9,0,0,1,.29,4.68c-.09.58-1,.33-.91-.25a8.46,8.46,0,0,0-.07-3.4,4.38,4.38,0,0,0-.63,0h-.28l-.35.08-.14.05-.06,0h0l-.26.14-.11.07h0l-.05,0-.2.2,0,0-.06.09-.14.24v0a.42.42,0,0,0,0,.1,1.34,1.34,0,0,0-.07.27.3.3,0,0,0,0,.1s0,0,0,.06a2.72,2.72,0,0,0,0,.28,1.64,1.64,0,0,0,0,.23.09.09,0,0,0,0,.05l0,.15a1.4,1.4,0,0,0,.09.29.69.69,0,0,0,.05.13.52.52,0,1,1,0,.07,1.35,1.35,0,0,0,.15.26.83.83,0,0,1,.08.12h0l.06.08a.46.46,0,0,1,0,.64.48.48,0,0,1-.67,0A3.11,3.11,0,0,1,254,337.71Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M313.48,293.75c7.65-4.9,12.29-12.58,11.13-22.79-.74-6.47-1.51-15.76-11.16-18.24-3.91-1-18.84-15-30.59-13.15-10.55,1.65-16.79,8.54-28,11.24-17.41,4.17-26.07,10-26.69,16.36s2.91,11.78-1.5,19.81c-5.11,9.33-9.83,10.78-11.81,18.12-1.06,3.93,1.6,4.39,6.59,17.7,3.76,10.05,1.4,17,4.76,18.58,6.74,3.09,10.84-6.11,17-7.38,8-1.65,14.31-5.75,15-6.65,4.42-6.19-3-13.28.74-17.14,4.13-4.26,13.76,3.89,27.53.38,8.52-2.17,19.16-2,21.52-4.06C315.64,299.74,308.55,296.9,313.48,293.75Z"
          fill="#02594f"
        />
        <path
          d="M276.61,337.4,299.55,336a17.52,17.52,0,0,0,0,5.27c1.12,7.86,7.09,13.54,13.3,12.66,5.78-.83,9.75-7,9.39-14.22l2.41-.34c-.38-.85-1-1.73-1.35-2.4l-1.38.17c-1.44-7.38-7.17-12.59-13.14-11.74-4.05.58-7.21,3.81-8.61,8.16L276.71,335Zm24.9,3.6c-.92-6.46,2.49-12.32,7.6-13s10,3.94,10.93,10.4-2.48,12.32-7.59,13.05S302.44,347.47,301.51,341Z"
          fill="#f4e2ca"
        />
        <g opacity={0.15}>
          <path
            d="M291.16,460.55c-7.83,2-17.69,1.34-27.12-1.91-.86-.3-1.57-.9-1.56-1.57s.79-1,1.64-.74c9,3.1,18.08,3.74,25.52,1.8a2.41,2.41,0,0,1,2.17,1c.45.71.05,1.23-.65,1.42Z"
            fill="#281a24"
          />
        </g>
        <path
          d="M312.58,320c.68-1.09,0-1.61-2.31-1.91a22.64,22.64,0,0,0-7.11.44c-4.71,1.08-7.06,4.15-5.72,3.59,2.25-.94,4.12-1.48,9-1.92C309,320,312.13,320.77,312.58,320Z"
          fill="#052620"
        />
        <path
          d="M214.6,972.1s3.16,60.44,0,84.42"
          fill="none"
          stroke="#281a24"
          strokeMiterlimit={10}
          opacity={0.35}
        />
        <path
          d="M301.41,281.26a8.53,8.53,0,0,0-7.53,1.42c-2.42,1.65-4.07,4.09-5.74,6.45a23,23,0,0,1-6.09,6.28,18.56,18.56,0,0,1-7.9,2.89c-6,.72-12.08-1.5-18.1-.4a12.9,12.9,0,0,0-10.46,10.45,13,13,0,0,1-1.5,5,17.74,17.74,0,0,1-3.38,3.65,29.14,29.14,0,0,1-8.6,5.19c-.59.23-.33,1.2.27,1a30.41,30.41,0,0,0,7.64-4.29c2.12-1.65,4.47-3.66,5.57-6.18a22.61,22.61,0,0,0,1-4.46,11.48,11.48,0,0,1,1.35-3.62,11.68,11.68,0,0,1,6.08-5.1c5.69-2,11.87,0,17.71,0a19.83,19.83,0,0,0,14.78-6.62c2.18-2.49,3.74-5.48,6.09-7.83,2.17-2.17,5.41-3.84,8.49-2.76.61.21.87-.76.27-1Z"
          fill="#097263"
        />
        <path
          d="M260.71,286.81a18.07,18.07,0,0,0-8.95,1.6c-1.45.59-2.87,1.27-4.28,2a29,29,0,0,0-3.57,2,11.25,11.25,0,0,0-2.82,2.64,12.73,12.73,0,0,0-1.69,3.78A23.13,23.13,0,0,1,238,302.9a9.93,9.93,0,0,1-2.34,2.9,15.64,15.64,0,0,1-7.94,3.25c-.63.09-.36,1.05.27,1a17.22,17.22,0,0,0,7-2.51,11.28,11.28,0,0,0,4.54-5.75c.95-2.66,1.35-5.44,3.52-7.45s4.87-3.08,7.4-4.24c3.22-1.47,6.67-2.68,10.26-2.25.64.08.63-.92,0-1Z"
          fill="#097263"
        />
        <g>
          <path
            d="M227.78,676.48c7.24,7.11,18.49,7.74,24.36,8.44,20.67,2.44,27.72-10,42-4.95,10.2,3.62,18.94,24.26,24.64,20.44,4.22-2.83-.93-9.93-5.59-17-4.57-6.91-9.36-10.64-8.76-11.49.94-1.31,6-1.19,10,1.46,6.83,4.57,6.59,11.52,12.64,17.35,2.14,2.07,5.1,2.1,6.44.53,2.34-2.75-1.41-8.31-1.41-8.31,2.65-.2,4-2.21,3.91-4.94-.1-6.53-10.23-25.67-20-30.18-8.94-4.14-25.54-4.59-28.83-4.12-13.12,1.85-19.5,6.48-29.12,4.34-6.08-1.36-7.52-2.9-10.94-4.61A153.24,153.24,0,0,0,235.63,659,101.13,101.13,0,0,0,227.78,676.48Z"
            fill="#dba795"
          />
          <g opacity={0.7}>
            <path
              d="M331.33,681.87A119.65,119.65,0,0,0,320,663.73c-4.47-5.76-11.4-7.18-18.22-8.33-.76-.13-.61-1.32.16-1.19,6.54,1.1,13.51,2.45,18.1,7.67,5,5.7,8.9,12.84,12.39,19.54.36.69-.76,1.13-1.11.45Z"
              fill="#dba795"
              opacity={0.5}
              style={{
                mixBlendMode: "multiply",
              }}
            />
          </g>
        </g>
        <path
          d="M330.61,722.12l14.73,50.68S347.07,789,349,792s-23.19,2.15-23.19,2.15S329.23,736.24,330.61,722.12Z"
          fill="#f15931"
        />
        <path
          d="M331,742.77a111.31,111.31,0,0,0,13-.74"
          fill="none"
          stroke="#f9f5ec"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
        />
      </g>
      <g id="light">
        <polygon
          points="200.39 3 960 649 959 1080 939 1080 362.54 1079 200.39 3"
          opacity={0.15}
          fill="url(#linear-gradient)"
        />
      </g>
      <g id="Layer_11" data-name="Layer 11">
        <path
          d="M310,366.39s2.59,3.12,8.24,2.13"
          fill="none"
          stroke="#9e695c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
      </g>
      <g id="Layer_12" data-name="Layer 12">
        <polygon
          points="0 936 749.01 939.33 957 1080 0.14 1080.37 0 936"
          fill="#f4d6ab"
        />
        <ellipse cx={165.5} cy={1041} rx={40.5} ry={10} fill="#e2c7a1" />
        <ellipse cx={207.5} cy={998} rx={40.5} ry={10} fill="#e2c7a1" />
        <ellipse cx={689.5} cy={1002} rx={40.5} ry={10} fill="#e2c7a1" />
        <g>
          <rect
            x={261}
            y={890}
            width={10}
            height={45}
            rx={2.11}
            transform="translate(-82.67 28.28) rotate(-5.27)"
            fill="#cfe6fa"
          />
          <rect
            x={537}
            y={892}
            width={10}
            height={45}
            rx={2.11}
            transform="translate(997.73 1874.91) rotate(-174.73)"
            fill="#cfe6fa"
          />
          <path
            d="M510.43,1013H295.69c-9.65,0-18.69-6-19.53-16.44L266,873.37c0-.25,0-.5,0-.74,0-6,.91-9.63,7-9.63H528c16,0,14,2.78,14,9L530,996.23a9.26,9.26,0,0,1-.13.92A19.82,19.82,0,0,1,510.43,1013Z"
            fill="#2c5bb0"
          />
          <path
            d="M538,907l-18.49-1c-8.18-.26-15.29,6-16.69,14.7L495,1013l19.39-.5c8.23-.16,15.2-6.56,16.67-15.28Z"
            fill="#255195"
          />
          <path
            d="M269,907l18.49-1c8.18-.26,15.29,6,16.69,14.7L312,1013l-19.39-.5c-8.23-.16-15.2-6.56-16.67-15.28Z"
            fill="#255195"
          />
          <path
            d="M349.59,991H457.41A10.59,10.59,0,0,1,468,1001.59V1013a0,0,0,0,1,0,0H339a0,0,0,0,1,0,0v-11.41A10.59,10.59,0,0,1,349.59,991Z"
            fill="#255195"
          />
          <path
            d="M283.34,824H527.72a17.36,17.36,0,0,1,17.36,17.36V849a0,0,0,0,1,0,0H262.93a0,0,0,0,1,0,0v-4.59A20.41,20.41,0,0,1,283.34,824Z"
            fill="#c1ddfa"
          />
          <rect
            x={256}
            y={846}
            width={297}
            height={17}
            rx={8.5}
            fill="#cfe6fa"
          />
          <path
            d="M366,863h63a0,0,0,0,1,0,0v0a19,19,0,0,1-19,19H385a19,19,0,0,1-19-19v0A0,0,0,0,1,366,863Z"
            fill="#255196"
          />
          <path
            d="M366,863h62a0,0,0,0,1,0,0v0a8,8,0,0,1-8,8H374a8,8,0,0,1-8-8v0a0,0,0,0,1,0,0Z"
            fill="#1f487e"
          />
          <path
            d="M312,863h41a0,0,0,0,1,0,0v27.81a6.19,6.19,0,0,1-6.19,6.19H318.19a6.19,6.19,0,0,1-6.19-6.19V863A0,0,0,0,1,312,863Z"
            fill="#1f487e"
          />
          <path
            d="M446,863h41a0,0,0,0,1,0,0v27.81a6.19,6.19,0,0,1-6.19,6.19H452.19a6.19,6.19,0,0,1-6.19-6.19V863A0,0,0,0,1,446,863Z"
            fill="#1f487e"
          />
          <rect
            x={315}
            y={846}
            width={35}
            height={46}
            rx={5.44}
            fill="#e8f4fb"
          />
          <rect
            x={449}
            y={847}
            width={35}
            height={46}
            rx={5.44}
            fill="#e8f4fb"
          />
          <path
            d="M346.91,879V865.38a2.41,2.41,0,0,0-2.45-2.38H320.54a2.41,2.41,0,0,0-2.45,2.38V879H315v3h35v-3Z"
            fill="#97aebb"
          />
          <path
            d="M480.91,880V866.38a2.41,2.41,0,0,0-2.45-2.38H454.54a2.41,2.41,0,0,0-2.45,2.38V880H449v3h35v-3Z"
            fill="#97aebb"
          />
          <rect x={456} y={868} width={21} height={8} rx={1.45} fill="#fff" />
          <rect x={322} y={867} width={21} height={8} rx={1.46} fill="#fff" />
        </g>
        <g>
          <path
            d="M168.05,911h6.39v5.56h-6.39a1.49,1.49,0,0,1-1.34-1.61v-2.34A1.49,1.49,0,0,1,168.05,911Z"
            fill="#eda60a"
          />
          <g>
            <path
              d="M165.47,924.8a12.22,12.22,0,0,0,4-6.43l.09-.34a3.27,3.27,0,0,1,3-2.63h36.17a3.28,3.28,0,0,1,3,2.63l.09.34a12.16,12.16,0,0,0,4,6.43h0a4,4,0,0,1,1.4,3.14v66.52a4,4,0,0,1-1.4,3.15h0a12.16,12.16,0,0,0-4,6.43l-.09.33a3.28,3.28,0,0,1-3,2.64H172.59a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a4,4,0,0,1-1.41-3.15V927.94a4,4,0,0,1,1.41-3.14Z"
              fill="url(#New_Pattern_Swatch_8-7)"
            />
            <path
              d="M165.47,924.8a12.22,12.22,0,0,0,4-6.43l.09-.34a3.27,3.27,0,0,1,3-2.63h7.73a3.27,3.27,0,0,0-3,2.63l-.09.34a12.22,12.22,0,0,1-4,6.43,4,4,0,0,0-1.41,3.14v66.52a4,4,0,0,0,1.41,3.15h0a12.22,12.22,0,0,1,4,6.43l.09.33a3.27,3.27,0,0,0,3,2.64h-7.73a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a4,4,0,0,1-1.41-3.15V927.94A4,4,0,0,1,165.47,924.8Z"
              fill="#9fa2a5"
            />
            <path
              d="M217.12,995.65a3.73,3.73,0,0,1-1.24,2h0a12.1,12.1,0,0,0-4,6.43l-.09.33a3.28,3.28,0,0,1-3,2.64H172.59a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a3.75,3.75,0,0,1-1.25-2Z"
              fill="#e5ebf6"
            />
            <path
              d="M165.22,997.39l-.14-.14,0,0-.17-.21h0l-.14-.21,0,0-.12-.21,0,0a2.06,2.06,0,0,1-.12-.26h0c0-.09-.07-.17-.1-.26v0l-.09-.27H172a3.75,3.75,0,0,0,1.25,2h0a12.22,12.22,0,0,1,4,6.43l.09.33a3.27,3.27,0,0,0,3,2.64h-7.73a2.94,2.94,0,0,1-.51,0,2.9,2.9,0,0,1-.48-.14l-.23-.11a2.89,2.89,0,0,1-.44-.27l-.2-.16a3.74,3.74,0,0,1-1-1.62,2.46,2.46,0,0,1-.09-.29l-.09-.33a14,14,0,0,0-.86-2.35,11.26,11.26,0,0,0-.7-1.28c-.08-.14-.17-.27-.26-.4a10.66,10.66,0,0,0-1.19-1.46,10.05,10.05,0,0,0-1-.94h0l-.2-.17S165.24,997.41,165.22,997.39Z"
              fill="#d1dced"
            />
            <path
              d="M168.05,916.56H213.3a1.49,1.49,0,0,0,1.34-1.61v-2.34A1.49,1.49,0,0,0,213.3,911H168.05a1.49,1.49,0,0,0-1.34,1.61V915A1.49,1.49,0,0,0,168.05,916.56Z"
              fill="#ffbf14"
            />
            <ellipse
              cx={190.67}
              cy={956.35}
              rx={16.64}
              ry={26.87}
              fill="#ffdc6c"
            />
            <path
              d="M190.67,929.48a10.88,10.88,0,0,1,3.83.71c-7.35,2.79-12.82,13.45-12.82,26.16s5.47,23.37,12.82,26.16a10.66,10.66,0,0,1-3.83.71c-9.19,0-16.64-12-16.64-26.87S181.48,929.48,190.67,929.48Z"
              fill="#f7ce5e"
            />
            <path
              d="M174.29,963.78h32.77a3.08,3.08,0,0,0,2.76-3.32v-8.22a3.07,3.07,0,0,0-2.76-3.31H174.29a3.07,3.07,0,0,0-2.76,3.31v8.22A3.08,3.08,0,0,0,174.29,963.78Z"
              fill="#fff"
            />
            <path
              d="M174.29,948.93h4.86v14.85h-4.86a3.08,3.08,0,0,1-2.76-3.32v-8.22A3.07,3.07,0,0,1,174.29,948.93Z"
              fill="#f4f2ed"
            />
          </g>
        </g>
        <g>
          <path
            d="M126.05,953h6.39v5.56h-6.39a1.49,1.49,0,0,1-1.34-1.61v-2.34A1.49,1.49,0,0,1,126.05,953Z"
            fill="#eda60a"
          />
          <g>
            <path
              d="M123.47,966.8a12.22,12.22,0,0,0,4-6.43l.09-.34a3.27,3.27,0,0,1,3-2.63h36.17a3.28,3.28,0,0,1,3,2.63l.09.34a12.16,12.16,0,0,0,4,6.43h0a4,4,0,0,1,1.4,3.14v66.52a4,4,0,0,1-1.4,3.15h0a12.16,12.16,0,0,0-4,6.43l-.09.33a3.28,3.28,0,0,1-3,2.64H130.59a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a4,4,0,0,1-1.41-3.15V969.94a4,4,0,0,1,1.41-3.14Z"
              fill="url(#New_Pattern_Swatch_8-9)"
            />
            <path
              d="M123.47,966.8a12.22,12.22,0,0,0,4-6.43l.09-.34a3.27,3.27,0,0,1,3-2.63h7.73a3.27,3.27,0,0,0-3,2.63l-.09.34a12.22,12.22,0,0,1-4,6.43,4,4,0,0,0-1.41,3.14v66.52a4,4,0,0,0,1.41,3.15h0a12.22,12.22,0,0,1,4,6.43l.09.33a3.27,3.27,0,0,0,3,2.64h-7.73a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a4,4,0,0,1-1.41-3.15V969.94A4,4,0,0,1,123.47,966.8Z"
              fill="#9fa2a5"
            />
            <path
              d="M175.12,1037.65a3.73,3.73,0,0,1-1.24,2h0a12.1,12.1,0,0,0-4,6.43l-.09.33a3.28,3.28,0,0,1-3,2.64H130.59a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a3.75,3.75,0,0,1-1.25-2Z"
              fill="#e5ebf6"
            />
            <path
              d="M123.22,1039.39l-.14-.14,0,0-.17-.21h0l-.14-.21,0,0-.12-.21,0,0a2.06,2.06,0,0,1-.12-.26h0c0-.09-.07-.17-.1-.26v0l-.09-.27H130a3.75,3.75,0,0,0,1.25,2h0a12.22,12.22,0,0,1,4,6.43l.09.33a3.27,3.27,0,0,0,3,2.64h-7.73a2.94,2.94,0,0,1-.51,0,2.9,2.9,0,0,1-.48-.14l-.23-.11a2.89,2.89,0,0,1-.44-.27l-.2-.16a3.74,3.74,0,0,1-1-1.62,2.46,2.46,0,0,1-.09-.29l-.09-.33a14,14,0,0,0-.86-2.35,11.26,11.26,0,0,0-.7-1.28c-.08-.14-.17-.27-.26-.4a10.66,10.66,0,0,0-1.19-1.46,10.05,10.05,0,0,0-1-.94h0l-.2-.17Z"
              fill="#d1dced"
            />
            <path
              d="M126.05,958.56H171.3a1.49,1.49,0,0,0,1.34-1.61v-2.34A1.49,1.49,0,0,0,171.3,953H126.05a1.49,1.49,0,0,0-1.34,1.61V957A1.49,1.49,0,0,0,126.05,958.56Z"
              fill="#ffbf14"
            />
            <ellipse
              cx={148.67}
              cy={998.35}
              rx={16.64}
              ry={26.87}
              fill="#ffdc6c"
            />
            <path
              d="M148.67,971.48a10.88,10.88,0,0,1,3.83.71c-7.35,2.79-12.82,13.45-12.82,26.16s5.47,23.37,12.82,26.16a10.66,10.66,0,0,1-3.83.71c-9.19,0-16.64-12-16.64-26.87S139.48,971.48,148.67,971.48Z"
              fill="#f7ce5e"
            />
            <path
              d="M132.29,1005.78h32.77a3.08,3.08,0,0,0,2.76-3.32v-8.22a3.07,3.07,0,0,0-2.76-3.31H132.29a3.07,3.07,0,0,0-2.76,3.31v8.22A3.08,3.08,0,0,0,132.29,1005.78Z"
              fill="#fff"
            />
            <path
              d="M132.29,990.93h4.86v14.85h-4.86a3.08,3.08,0,0,1-2.76-3.32v-8.22A3.07,3.07,0,0,1,132.29,990.93Z"
              fill="#f4f2ed"
            />
          </g>
        </g>
        <g>
          <path
            d="M651.05,913h6.39v5.56h-6.39a1.49,1.49,0,0,1-1.34-1.61v-2.34A1.49,1.49,0,0,1,651.05,913Z"
            fill="#eda60a"
          />
          <g>
            <path
              d="M648.47,926.8a12.22,12.22,0,0,0,4-6.43l.09-.34a3.27,3.27,0,0,1,3-2.63h36.17a3.28,3.28,0,0,1,3,2.63l.09.34a12.16,12.16,0,0,0,4,6.43h0a4,4,0,0,1,1.4,3.14v66.52a4,4,0,0,1-1.4,3.15h0a12.16,12.16,0,0,0-4,6.43l-.09.33a3.28,3.28,0,0,1-3,2.64H655.59a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a4,4,0,0,1-1.41-3.15V929.94a4,4,0,0,1,1.41-3.14Z"
              fill="url(#New_Pattern_Swatch_8-11)"
            />
            <path
              d="M648.47,926.8a12.22,12.22,0,0,0,4-6.43l.09-.34a3.27,3.27,0,0,1,3-2.63h7.73a3.27,3.27,0,0,0-3,2.63l-.09.34a12.22,12.22,0,0,1-4,6.43,4,4,0,0,0-1.41,3.14v66.52a4,4,0,0,0,1.41,3.15h0a12.22,12.22,0,0,1,4,6.43l.09.33a3.27,3.27,0,0,0,3,2.64h-7.73a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a4,4,0,0,1-1.41-3.15V929.94A4,4,0,0,1,648.47,926.8Z"
              fill="#9fa2a5"
            />
            <path
              d="M700.12,997.65a3.73,3.73,0,0,1-1.24,2h0a12.1,12.1,0,0,0-4,6.43l-.09.33a3.28,3.28,0,0,1-3,2.64H655.59a3.27,3.27,0,0,1-3-2.64l-.09-.33a12.22,12.22,0,0,0-4-6.43h0a3.75,3.75,0,0,1-1.25-2Z"
              fill="#e5ebf6"
            />
            <path
              d="M648.22,999.39l-.14-.14,0,0-.17-.21h0l-.14-.21,0,0-.12-.21,0,0a2.06,2.06,0,0,1-.12-.26h0c0-.09-.07-.17-.1-.26v0l-.09-.27H655a3.75,3.75,0,0,0,1.25,2h0a12.22,12.22,0,0,1,4,6.43l.09.33a3.27,3.27,0,0,0,3,2.64h-7.73a2.94,2.94,0,0,1-.51,0,2.9,2.9,0,0,1-.48-.14l-.23-.11a2.89,2.89,0,0,1-.44-.27l-.2-.16a3.74,3.74,0,0,1-1.05-1.62,2.46,2.46,0,0,1-.09-.29l-.09-.33a14,14,0,0,0-.86-2.35,11.26,11.26,0,0,0-.7-1.28c-.08-.14-.17-.27-.26-.4a10.66,10.66,0,0,0-1.19-1.46,10.05,10.05,0,0,0-1-.94h0l-.2-.17S648.24,999.41,648.22,999.39Z"
              fill="#d1dced"
            />
            <path
              d="M651.05,918.56H696.3a1.49,1.49,0,0,0,1.34-1.61v-2.34A1.49,1.49,0,0,0,696.3,913H651.05a1.49,1.49,0,0,0-1.34,1.61V917A1.49,1.49,0,0,0,651.05,918.56Z"
              fill="#ffbf14"
            />
            <ellipse
              cx={673.67}
              cy={958.35}
              rx={16.64}
              ry={26.87}
              fill="#ffdc6c"
            />
            <path
              d="M673.67,931.48a10.88,10.88,0,0,1,3.83.71c-7.35,2.79-12.82,13.45-12.82,26.16s5.47,23.37,12.82,26.16a10.66,10.66,0,0,1-3.83.71c-9.19,0-16.64-12-16.64-26.87S664.48,931.48,673.67,931.48Z"
              fill="#f7ce5e"
            />
            <path
              d="M657.29,965.78h32.77a3.08,3.08,0,0,0,2.76-3.32v-8.22a3.07,3.07,0,0,0-2.76-3.31H657.29a3.07,3.07,0,0,0-2.76,3.31v8.22A3.08,3.08,0,0,0,657.29,965.78Z"
              fill="#fff"
            />
            <path
              d="M657.29,950.93h4.86v14.85h-4.86a3.08,3.08,0,0,1-2.76-3.32v-8.22A3.07,3.07,0,0,1,657.29,950.93Z"
              fill="#f4f2ed"
            />
          </g>
        </g>
        <rect y={1080} width={957} height={64} fill="#ddbf9e" />
        <rect y={1207} width={957} height={64} fill="#ddbf9e" />
      </g>
    </g>
  </svg>
)

export default SvgConsentTwo
